(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "pl-PL", {
        style: "currency",
        currency,
      }).format(cents / 100);
    } catch (_error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const setBodyLock = (locked) =>
    document.body.classList.toggle("is-locked", locked);

  const shopRoot = () => window.Shopify?.routes?.root || "/";
  const announce = (message) => {
    const region = document.querySelector("[data-live-region]");
    if (region) region.textContent = message;
  };
  const setShippingStatus = (root, inventoryQuantity) => {
    if (!root) return;
    const isInStock = Number(inventoryQuantity) > 0;
    const text = root.querySelector("[data-shipping-status-text]");
    root.classList.toggle("is-in-stock", isInStock);
    root.classList.toggle("is-order", !isInStock);
    if (text)
      text.textContent = isInStock
        ? root.dataset.inStockText
        : root.dataset.orderText;
  };
  const addCartItem = async (id, quantity = 1) => {
    const response = await fetch(`${shopRoot()}cart/add.js`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok)
      throw new Error(result.description || "Nie udało się dodać produktu.");
    const cartResponse = await fetch(`${shopRoot()}cart.js`, {
      headers: { Accept: "application/json" },
    });
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll(".cp-site-count").forEach((counter) => {
        counter.textContent = String(cart.item_count);
        counter
          .closest("a")
          ?.setAttribute("aria-label", `Koszyk, produktów: ${cart.item_count}`);
      });
    }
    return result;
  };

  let quickAddInitialized = false;
  const productCache = new Map();
  const inventoryCache = new Map();
  const initQuickAdd = () => {
    if (quickAddInitialized) return;
    const dialog = document.querySelector("[data-quick-add-dialog]");
    if (!dialog) return;
    quickAddInitialized = true;
    const title = dialog.querySelector("[data-quick-add-title]");
    const image = dialog.querySelector("[data-quick-add-image]");
    const price = dialog.querySelector("[data-quick-add-price]");
    const shippingStatus = dialog.querySelector("[data-shipping-status]");
    const form = dialog.querySelector("[data-quick-add-form]");
    const optionsRoot = dialog.querySelector("[data-quick-add-options]");
    const variantInput = dialog.querySelector("[data-quick-add-variant]");
    const submit = dialog.querySelector("[data-quick-add-submit]");
    const buyNow = dialog.querySelector("[data-quick-add-buy-now]");
    const quantity = dialog.querySelector("[data-quick-add-quantity]");
    const quantityMinus = dialog.querySelector(
      "[data-quick-add-quantity-minus]",
    );
    const quantityPlus = dialog.querySelector("[data-quick-add-quantity-plus]");
    const message = dialog.querySelector("[data-quick-add-message]");
    const currency = dialog.dataset.currency || "PLN";
    let activeProduct;

    const getInventory = async (button, handle) => {
      if (button.dataset.variantInventory)
        return JSON.parse(button.dataset.variantInventory);
      if (!inventoryCache.has(handle)) {
        inventoryCache.set(
          handle,
          fetch(`${shopRoot()}products/${encodeURIComponent(handle)}`)
            .then((response) => {
              if (!response.ok) return [];
              return response.text();
            })
            .then((html) => {
              const page = new DOMParser().parseFromString(html, "text/html");
              const data = page.querySelector("[data-product-inventory-json]");
              return data ? JSON.parse(data.textContent || "[]") : [];
            })
            .catch(() => []),
        );
      }
      return inventoryCache.get(handle);
    };

    const getProduct = async (button) => {
      const handle = button.dataset.productHandle;
      if (button.quickProduct) productCache.set(handle, button.quickProduct);
      if (!productCache.has(handle)) {
        productCache.set(
          handle,
          fetch(`${shopRoot()}products/${encodeURIComponent(handle)}.js`).then(
            (response) => {
              if (!response.ok)
                throw new Error("Nie udało się wczytać produktu.");
              return response.json();
            },
          ),
        );
      }
      const product = await productCache.get(handle);
      const inventory = await getInventory(button, handle);
      product.variants.forEach((variant, index) => {
        variant.inventory_quantity = Number(inventory[index] || 0);
      });
      return product;
    };

    const imageSource = (product, variant) =>
      variant?.featured_image?.src ||
      variant?.featured_image ||
      product.featured_image?.src ||
      product.featured_image ||
      product.images?.[0] ||
      "";

    const updateVariant = () => {
      if (!activeProduct) return;
      const selected = [...optionsRoot.querySelectorAll("select")].map(
        (select) => select.value,
      );
      const variant = activeProduct.variants.find((item) =>
        item.options.every((option, index) => option === selected[index]),
      );
      if (!variant) {
        variantInput.value = "";
        submit.disabled = true;
        buyNow.disabled = true;
        submit.textContent = "Wybierz dostępny wariant";
        return;
      }
      variantInput.value = variant.id;
      submit.disabled = !variant.available;
      buyNow.disabled = !variant.available;
      submit.textContent = variant.available
        ? "Dodaj do koszyka"
        : "Wariant niedostępny";
      setShippingStatus(shippingStatus, variant.inventory_quantity);
      price.replaceChildren();
      const current = document.createElement("span");
      current.textContent = money(variant.price, currency);
      price.append(current);
      if (variant.compare_at_price > variant.price) {
        const compare = document.createElement("s");
        compare.textContent = money(variant.compare_at_price, currency);
        price.append(compare);
      }
      const source = imageSource(activeProduct, variant);
      if (source) image.src = source;
    };

    const openProduct = (product) => {
      activeProduct = product;
      title.textContent = product.title;
      image.alt = product.title;
      message.textContent = "";
      form.reset();
      optionsRoot.replaceChildren();
      const initialVariant =
        product.variants.find((variant) => variant.available) ||
        product.variants[0];
      const productOptions = product.options || [];
      productOptions.forEach((option, index) => {
        const name = typeof option === "string" ? option : option.name;
        if (name === "Title" && productOptions.length === 1) return;
        const values = (typeof option === "object" && option.values) || [
          ...new Set(product.variants.map((variant) => variant.options[index])),
        ];
        const label = document.createElement("label");
        label.className = "cp-quick-add__option";
        const caption = document.createElement("span");
        caption.textContent = name;
        const select = document.createElement("select");
        select.setAttribute("aria-label", name);
        values.forEach((value) => {
          const choice = document.createElement("option");
          choice.value = value;
          choice.textContent = value;
          choice.selected = initialVariant?.options[index] === value;
          select.append(choice);
        });
        select.addEventListener("change", updateVariant);
        label.append(caption, select);
        optionsRoot.append(label);
      });
      updateVariant();
      setBodyLock(true);
      dialog.showModal();
    };

    quantityMinus?.addEventListener("click", () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
    });
    quantityPlus?.addEventListener("click", () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
    });
    quantity?.addEventListener("change", () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1)));
    });

    document.addEventListener("click", async (event) => {
      const button = event.target.closest("[data-card-add]");
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = "Chwileczkę…";
      try {
        if (button.dataset.hasOptions === "true") {
          openProduct(await getProduct(button));
          button.disabled = false;
          button.textContent = original;
          return;
        }
        await addCartItem(button.dataset.variantId, 1);
        button.textContent = "Dodano ✓";
        announce(`${button.dataset.productTitle} dodano do koszyka.`);
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1400);
      } catch (error) {
        button.disabled = false;
        button.textContent = original;
        announce(error.message);
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!variantInput.value || submit.disabled) return;
      const quantity = Math.max(1, Number(form.elements.quantity?.value || 1));
      message.textContent = "";
      submit.disabled = true;
      buyNow.disabled = true;
      submit.textContent = "Dodawanie…";
      try {
        await addCartItem(variantInput.value, quantity);
        message.textContent = "Produkt dodany do koszyka.";
        submit.textContent = "Dodano ✓";
        announce(`${activeProduct.title} dodano do koszyka.`);
        window.setTimeout(() => dialog.close(), 700);
      } catch (error) {
        message.textContent = error.message;
        submit.disabled = false;
        buyNow.disabled = false;
        submit.textContent = "Dodaj do koszyka";
      }
    });

    buyNow.addEventListener("click", async () => {
      if (!variantInput.value || buyNow.disabled) return;
      const quantity = Math.max(1, Number(form.elements.quantity?.value || 1));
      message.textContent = "";
      buyNow.disabled = true;
      submit.disabled = true;
      buyNow.classList.add("is-loading");
      buyNow.setAttribute("aria-busy", "true");
      try {
        await addCartItem(variantInput.value, quantity);
        window.location.assign(`${shopRoot()}checkout`);
      } catch (error) {
        message.textContent = error.message;
        buyNow.disabled = false;
        submit.disabled = false;
        buyNow.classList.remove("is-loading");
        buyNow.removeAttribute("aria-busy");
      }
    });

    dialog
      .querySelector("[data-quick-add-close]")
      ?.addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", () => {
      setBodyLock(false);
      activeProduct = null;
    });
  };

  let headerOffsetInitialized = false;
  const initHeaderOffset = () => {
    if (headerOffsetInitialized) return;
    const headerGroups = [
      ...document.querySelectorAll(".shopify-section-group-header-group"),
    ];
    if (!headerGroups.length) return;
    headerOffsetInitialized = true;
    const sync = () => {
      const height = headerGroups.reduce(
        (total, group) =>
          total + Math.max(0, group.getBoundingClientRect().height),
        0,
      );
      document.documentElement.style.setProperty(
        "--cp-header-stack-height",
        `${height}px`,
      );
    };
    sync();
    window.addEventListener("resize", sync, { passive: true });
    if ("ResizeObserver" in window)
      headerGroups.forEach((group) => new ResizeObserver(sync).observe(group));
  };

  const collectionVendorCounts = new Map();
  const readCollectionVendors = (page) => {
    const counts = new Map();
    page.querySelectorAll("[data-product-grid] .cp-product-tile__vendor").forEach((element) => {
      const vendor = element.textContent.trim();
      if (vendor) counts.set(vendor, (counts.get(vendor) || 0) + 1);
    });
    return counts;
  };
  const collectionProductTotal = (page) => {
    const label = page.querySelector(".cp-collection-toolbar__count")?.textContent || "";
    const match = label.match(/\bz\s+([\d\s\u00a0]+)\s+produkt/i);
    return match ? Number(match[1].replace(/\D/g, "")) : null;
  };
  const initCollection = (scope = document) => {
    initHeaderOffset();
    scope.querySelectorAll("[data-collection-listing]").forEach((root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";

      const panel = root.querySelector("[data-filter-panel]");
      const scrim = root.querySelector(".cp-filter-scrim");
      const trigger = root.querySelector("[data-filter-open]");
      const closeFilter = () => {
        panel?.classList.remove("is-open");
        scrim?.classList.remove("is-open");
        trigger?.setAttribute("aria-expanded", "false");
        setBodyLock(false);
      };
      trigger?.addEventListener("click", () => {
        panel?.classList.add("is-open");
        scrim?.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        setBodyLock(true);
        panel?.querySelector("[data-filter-close]")?.focus();
      });
      root
        .querySelectorAll("[data-filter-close]")
        .forEach((button) => button.addEventListener("click", closeFilter));
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && panel?.classList.contains("is-open")) {
          closeFilter();
          trigger?.focus();
        }
      });

      const filterForm = root.querySelector("[data-filter-form]");
      if (filterForm) {
        const vendorCheckboxes = [
          ...filterForm.querySelectorAll('input[name="filter.p.vendor"]'),
        ];
        const hasNativeVendorFilter =
          filterForm.dataset.nativeVendorFilter === "true" ||
          vendorCheckboxes.some((input) =>
            input.closest("label")?.querySelector("small"),
          );
        const vendorCollectionUrl =
          filterForm.dataset.vendorCollectionUrl ||
          (!hasNativeVendorFilter && vendorCheckboxes.length
            ? `${shopRoot()}collections/vendors`
            : null);

        const pageUrl = new URL(window.location.href);
        const activeVendors = pageUrl.searchParams.getAll("filter.p.vendor");
        vendorCheckboxes.forEach((input) => {
          if (activeVendors.includes(input.value)) input.checked = true;
        });
        if (vendorCheckboxes.length && !pageUrl.pathname.replace(/\/$/, "").endsWith("/collections/vendors")) {
          const vendorList = vendorCheckboxes[0].closest("ul");
          const status = document.createElement("p");
          status.textContent = "Wczytywanie producentów…";
          status.setAttribute("role", "status");
          vendorList?.insertAdjacentElement("afterend", status);
          if (vendorList) vendorList.style.display = "none";

          const baseUrl = new URL(filterForm.action, window.location.origin);
          const sort = filterForm.querySelector('input[name="sort_by"]')?.value;
          if (sort) baseUrl.searchParams.set("sort_by", sort);
          const cacheKey = baseUrl.toString();
          const loadCounts = async () => {
            const noProductFilter = ![...pageUrl.searchParams.keys()].some((key) =>
              key.startsWith("filter.") || key === "q" || key === "page",
            );
            let firstPage = document;
            if (pageUrl.pathname !== baseUrl.pathname || !noProductFilter) {
              const response = await fetch(baseUrl.toString(), { credentials: "same-origin" });
              if (!response.ok) throw new Error("Nie udało się pobrać kolekcji");
              firstPage = new DOMParser().parseFromString(await response.text(), "text/html");
            }
            const total = collectionProductTotal(firstPage);
            const firstCounts = readCollectionVendors(firstPage);
            const firstPageSize = firstPage.querySelectorAll("[data-product-grid] .cp-product-tile").length;
            if (total === null || (total > 0 && firstPageSize === 0)) {
              throw new Error("Nie można odczytać liczby produktów");
            }
            if (total <= firstPageSize) return firstCounts;

            const pages = Math.ceil(total / firstPageSize);
            let nextPage = 2;
            let loaded = firstPageSize;
            const workers = Array.from({ length: Math.min(3, pages - 1) }, async () => {
              while (nextPage <= pages) {
                const number = nextPage++;
                const url = new URL(baseUrl);
                url.searchParams.set("page", String(number));
                const response = await fetch(url.toString(), { credentials: "same-origin" });
                if (!response.ok) throw new Error("Nie udało się pobrać produktów");
                const page = new DOMParser().parseFromString(await response.text(), "text/html");
                const cards = page.querySelectorAll("[data-product-grid] .cp-product-tile").length;
                if (!cards) throw new Error("Brak produktów na stronie kolekcji");
                loaded += cards;
                readCollectionVendors(page).forEach((count, vendor) => {
                  firstCounts.set(vendor, (firstCounts.get(vendor) || 0) + count);
                });
              }
            });
            await Promise.all(workers);
            if (loaded !== total) throw new Error("Liczba produktów w kolekcji się zmieniła");
            return firstCounts;
          };
          const updateVendors = async () => {
            if (!collectionVendorCounts.has(cacheKey)) {
              collectionVendorCounts.set(cacheKey, loadCounts());
            }
            try {
              const counts = await collectionVendorCounts.get(cacheKey);
              vendorCheckboxes.forEach((input) => {
                const count = counts.get(input.value) || 0;
                const item = input.closest("li");
                if (item) item.style.display = count ? "" : "none";
                if (count) {
                  const label = input.closest("label");
                  let number = label?.querySelector("small");
                  if (!number && label) {
                    number = document.createElement("small");
                    label.append(number);
                  }
                  if (number) number.textContent = String(count);
                }
              });
              if (vendorList) vendorList.style.display = "";
              status.remove();
            } catch (error) {
              collectionVendorCounts.delete(cacheKey);
              status.textContent = "Nie udało się wczytać producentów. Zamknij i otwórz filtry, aby spróbować ponownie.";
            }
          };
          trigger?.addEventListener("click", updateVendors);
        }
        if (pageUrl.pathname.replace(/\/$/, "").endsWith("/collections/vendors")) {
          const currentVendor = pageUrl.searchParams.get("q");
          const currentInput = [
            ...filterForm.querySelectorAll(
              'input[name="cp_vendor"], input[name="filter.p.vendor"]',
            ),
          ].find((input) => input.value === currentVendor);
          if (currentInput) currentInput.checked = true;
          const clearLink = filterForm.querySelector(
            ".cp-filter-panel__footer a",
          );
          if (clearLink) clearLink.href = `${shopRoot()}collections/all`;
        }

        if (vendorCollectionUrl) {
          vendorCheckboxes.forEach((input) => {
            input.addEventListener("change", () => {
              if (!input.checked) return;
              vendorCheckboxes.forEach((other) => {
                if (other !== input) other.checked = false;
              });
            });
          });

          filterForm.addEventListener("submit", (event) => {
            const selectedVendor = filterForm.querySelector(
              'input[name="cp_vendor"]:checked, input[name="filter.p.vendor"]:checked',
            );
            if (!selectedVendor) return;

            event.preventDefault();
            const url = new URL(vendorCollectionUrl, window.location.origin);
            url.searchParams.set("q", selectedVendor.value);
            new FormData(filterForm).forEach((value, key) => {
              if (key !== "cp_vendor" && key !== "filter.p.vendor" && value) {
                url.searchParams.append(key, value);
              }
            });
            window.location.assign(url.toString());
          });
        }
      }

      root
        .querySelector("[data-collection-sort]")
        ?.addEventListener("change", (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set("sort_by", event.target.value);
          window.location.assign(url.toString());
        });

      root.querySelectorAll("[data-density]").forEach((button) => {
        button.addEventListener("click", () => {
          root.style.setProperty(
            "--cp-listing-columns",
            button.dataset.density,
          );
          root
            .querySelectorAll("[data-density]")
            .forEach((item) =>
              item.classList.toggle("is-active", item === button),
            );
        });
      });

      root.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeFilter();
      });
    });
  };

  const initProduct = (scope = document) => {
    scope.querySelectorAll("[data-product-root]").forEach((root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";
      const slides = [...root.querySelectorAll("[data-media-id]")];
      const thumbs = [...root.querySelectorAll("[data-gallery-thumb]")];
      const counter = root.querySelector("[data-gallery-current]");
      const form = root.querySelector("[data-product-form]");
      const variantId = form?.querySelector("[data-variant-id]");
      const price = root.querySelector("[data-product-price]");
      const stickyPrice = root.querySelector("[data-sticky-price]");
      const submit = form?.querySelector("[data-add-to-cart]");
      const stickySubmit = root.querySelector("[data-sticky-submit]");
      const submitLabel = form?.querySelector("[data-add-label]");
      const addPrice = form?.querySelector("[data-add-price]");
      const buyNow = form?.querySelector("[data-buy-now]");
      const buyPrice = form?.querySelector("[data-buy-price]");
      const selectedVariant = form?.querySelector("[data-selected-variant]");
      const shippingStatus = root.querySelector("[data-shipping-status]");
      const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
      let currentSlide = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains("is-active")),
      );

      const showSlide = (indexOrId) => {
        const index =
          typeof indexOrId === "number"
            ? (indexOrId + slides.length) % slides.length
            : slides.findIndex(
                (slide) => slide.dataset.mediaId === String(indexOrId),
              );
        if (index < 0) return;
        currentSlide = index;
        slides.forEach((slide, itemIndex) =>
          slide.classList.toggle("is-active", itemIndex === index),
        );
        thumbs.forEach((thumb) =>
          thumb.classList.toggle(
            "is-active",
            thumb.dataset.galleryThumb === slides[index]?.dataset.mediaId,
          ),
        );
        if (counter) counter.textContent = String(index + 1);
      };

      thumbs.forEach((thumb) =>
        thumb.addEventListener("click", () =>
          showSlide(thumb.dataset.galleryThumb),
        ),
      );
      root
        .querySelector("[data-gallery-prev]")
        ?.addEventListener("click", () => showSlide(currentSlide - 1));
      root
        .querySelector("[data-gallery-next]")
        ?.addEventListener("click", () => showSlide(currentSlide + 1));

      root.querySelectorAll("[data-variant-choice]").forEach((choice) => {
        choice.addEventListener("change", () => {
          if (variantId) variantId.value = choice.value;
          const available = choice.dataset.available === "true";
          setShippingStatus(shippingStatus, choice.dataset.inventoryQuantity);
          if (price) {
            price.replaceChildren();
            const current = document.createElement("span");
            current.textContent = choice.dataset.price;
            price.append(current);
            if (choice.dataset.compare) {
              const compare = document.createElement("s");
              compare.textContent = choice.dataset.compare;
              price.append(compare);
            }
          }
          if (stickyPrice) stickyPrice.textContent = choice.dataset.price;
          if (submit) submit.disabled = !available;
          if (buyNow) buyNow.disabled = !available;
          if (stickySubmit) stickySubmit.disabled = !available;
          if (submitLabel) {
            submitLabel.textContent = available
              ? submit?.dataset.label || "Dodaj do koszyka"
              : "Niedostępny";
          }
          if (addPrice) {
            addPrice.textContent = choice.dataset.price;
            addPrice.hidden = !available;
          }
          if (buyPrice) buyPrice.textContent = choice.dataset.price;
          if (selectedVariant)
            selectedVariant.textContent = choice.dataset.title || "";
          if (choice.dataset.media) showSlide(choice.dataset.media);
        });
      });

      const quantity = form?.querySelector("[data-quantity-input]");
      form
        ?.querySelector("[data-quantity-minus]")
        ?.addEventListener("click", () => {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
        });
      form
        ?.querySelector("[data-quantity-plus]")
        ?.addEventListener("click", () => {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
        });
      stickySubmit?.addEventListener("click", () => submit?.click());

      buyNow?.addEventListener("click", async () => {
        if (!form || buyNow.disabled) return;
        const message = form.querySelector("[data-product-message]");
        buyNow.disabled = true;
        buyNow.classList.add("is-loading");
        buyNow.setAttribute("aria-busy", "true");
        try {
          const shopRoot = window.Shopify?.routes?.root || "/";
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: "POST",
            headers: { Accept: "application/json" },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error("Nie udało się dodać produktu.");
          window.location.assign(`${shopRoot}checkout`);
        } catch (error) {
          if (message) message.textContent = error.message;
          buyNow.disabled = false;
          buyNow.classList.remove("is-loading");
          buyNow.removeAttribute("aria-busy");
        }
      });

      root.querySelectorAll("[data-product-accordion]").forEach((details) => {
        const summary = details.querySelector("summary");
        const content = details.querySelector(".cp-product-accordion__content");
        if (!summary || !content) return;
        let animation;
        summary.setAttribute("aria-expanded", String(details.open));
        details.addEventListener("toggle", () => {
          summary.setAttribute("aria-expanded", String(details.open));
        });
        summary.addEventListener("click", (event) => {
          if (reducedMotion.matches || !details.animate) return;
          event.preventDefault();
          animation?.finish();
          const opening = !details.open;
          const startHeight = details.offsetHeight;
          if (opening) details.open = true;
          const endHeight =
            summary.offsetHeight + (opening ? content.offsetHeight : 0);
          summary.setAttribute("aria-expanded", String(opening));
          details.style.overflow = "hidden";
          animation = details.animate(
            { height: [`${startHeight}px`, `${endHeight}px`] },
            { duration: 340, easing: "cubic-bezier(0.22, 1, 0.36, 1)" },
          );
          animation.onfinish = () => {
            details.open = opening;
            details.style.removeProperty("overflow");
            animation = undefined;
          };
        });
      });

      const zoomDialog = root.querySelector("[data-product-zoom-dialog]");
      const zoomContent = zoomDialog?.querySelector(
        "[data-product-zoom-content]",
      );
      root
        .querySelector("[data-product-zoom]")
        ?.addEventListener("click", () => {
          const activeImage = slides[currentSlide]?.querySelector("img");
          if (!activeImage || !zoomDialog || !zoomContent) return;
          const zoomImage = activeImage.cloneNode(true);
          zoomImage.loading = "eager";
          zoomContent.replaceChildren(zoomImage);
          zoomDialog.showModal();
        });
      zoomDialog
        ?.querySelector("[data-product-zoom-close]")
        ?.addEventListener("click", () => zoomDialog.close());
      zoomDialog?.addEventListener("click", (event) => {
        if (event.target === zoomDialog) zoomDialog.close();
      });

      const sticky = root.querySelector("[data-sticky-buy]");
      if (sticky && submit && "IntersectionObserver" in window) {
        new IntersectionObserver(
          ([entry]) => {
            const visible =
              !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle("is-visible", visible);
            sticky.setAttribute("aria-hidden", String(!visible));
          },
          { threshold: 0 },
        ).observe(submit);
      }
    });
  };

  const buildRecentCard = (product, currency) => {
    const article = document.createElement("article");
    article.className = "cp-product-tile";
    const link = document.createElement("a");
    link.className = "cp-product-tile__link";
    link.href = product.url;
    const media = document.createElement("div");
    media.className = "cp-product-tile__media";
    if (product.featured_image) {
      const image = document.createElement("img");
      image.loading = "lazy";
      image.alt = product.title;
      image.src = product.featured_image;
      media.append(image);
    }
    const body = document.createElement("div");
    body.className = "cp-product-tile__body";
    const title = document.createElement("h3");
    title.textContent = product.title;
    const price = document.createElement("div");
    price.className = "cp-product-tile__price";
    const value = document.createElement("span");
    value.textContent = money(product.price, currency);
    price.append(value);
    body.append(title, price);
    link.append(media, body);
    const actions = document.createElement("div");
    actions.className = "cp-product-tile__actions";
    const add = document.createElement("button");
    add.className = "cp-product-tile__add";
    add.type = "button";
    add.dataset.cardAdd = "";
    add.dataset.productHandle = product.handle;
    add.dataset.productTitle = product.title;
    add.dataset.variantId = product.variants[0]?.id || "";
    add.dataset.hasOptions = String(
      product.variants.length > 1 ||
        product.options.some((option) =>
          typeof option === "string"
            ? option !== "Title"
            : option.name !== "Title",
        ),
    );
    add.quickProduct = product;
    add.disabled = !product.available;
    add.textContent = product.available ? "Dodaj do koszyka" : "Niedostępny";
    actions.append(add);
    article.append(link, actions);
    return article;
  };

  const initRecentlyViewed = async (scope = document) => {
    const root = scope.querySelector("[data-recently-viewed]");
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    const currentHandle = root.dataset.currentHandle;
    const limit = Number(root.dataset.limit || 4);
    const storageKey = "cp-recent-products";
    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(storageKey) || "[]");
      if (!Array.isArray(handles)) handles = [];
    } catch (_error) {
      handles = [];
    }
    const previous = handles
      .filter((handle) => handle !== currentHandle)
      .slice(0, limit);
    const shopRoot = window.Shopify?.routes?.root || "/";
    const products = (
      await Promise.all(
        previous.map((handle) =>
          fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`)
            .then((response) => (response.ok ? response.json() : null))
            .catch(() => null),
        ),
      )
    ).filter(Boolean);
    const grid = root.querySelector("[data-recent-grid]");
    products.forEach((product) =>
      grid?.append(buildRecentCard(product, root.dataset.currency || "PLN")),
    );
    if (products.length) root.hidden = false;
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify(
          [currentHandle, ...previous].filter(Boolean).slice(0, 12),
        ),
      );
    } catch (_error) {
      // Storage can be disabled without affecting the product page.
    }
  };

  const initProductRecommendations = (scope = document) => {
    scope.querySelectorAll("[data-product-recommendations]").forEach((root) => {
      if (root.dataset.initialized === "true" || !root.dataset.url) return;
      root.dataset.initialized = "true";
      const load = async () => {
        const response = await fetch(root.dataset.url);
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(
          await response.text(),
          "text/html",
        );
        const next = page.querySelector("[data-product-recommendations]");
        if (next?.innerHTML.trim()) root.innerHTML = next.innerHTML;
      };
      if (!("IntersectionObserver" in window)) {
        load();
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          observer.disconnect();
          load();
        },
        { rootMargin: "0px 0px 240px 0px" },
      );
      observer.observe(root);
    });
  };

  const init = (scope = document) => {
    initQuickAdd();
    initCollection(scope);
    initProduct(scope);
    initRecentlyViewed(scope);
    initProductRecommendations(scope);
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
})();
